
const commonRoutes = [
  {
    path: '/test',
    name: 'test', // 导航
    component: () => import('@views/test.vue'),
  },
  {
    path: '/gp/baike-aggregation/:tagId?',
    name: 'aggregation', // 聚合页
    meta: {
      pageType: 'aggregation',
      pageName: '聚合',
      keepAlive: true,
    },
    component: () => import(
      /* webpackChunkName: "aggregation" */
      '@views/common/aggregation/index.vue'),
  },
  {
    path: '/gp/news-detail/:id',
    name: 'news-detail',
    meta: {
      pageType: 'newsdetail',
      pageName: '图文详情页',
      keepAlive: false,
    },
    component: () => import(
      /* webpackChunkName: "news-detail" */
      '@views/common/news/index.vue'),
  },
  {
    path: '/gp/news-detail/:id/comment',
    name: 'news-detail-comment',
    meta: {
      pageType: 'news-detail-comment',
      pageName: '图文详情页-评论',
    },
    component: () => import(
      /* webpackChunkName: "comment-layer" */
      '@views/common/comment/index.vue'),
  },
  {
    path: '/gp/video-detail/:id',
    name: 'video-detail', // 视频详情
    meta: {
      pageType: 'videodetail',
      pageName: '视频详情页',
      keepAlive: false,
    },
    component: () => import(
      /* webpackChunkName: "video-detail" */ '@views/common/video-detail/index.vue'),
  },
  {
    path: '/gp/video-detail/:id/comment',
    name: 'video-detail-comment', // 视频详情-评论
    components: {
      comment: () => import(
        /* webpackChunkName: "comment-layer" */
        '@views/common/comment/index.vue'),
    },
  },
  {
    path: '*',
    redirect: () => ({
      name: 'index',
    }),
  },
];
export default commonRoutes;
